module.exports = __webpack_public_path__ + "img/down_logo.f4da556b.png";